import { Link } from "react-router-dom";

function BackButton({ to, label = "Back" }) {
  return (
    <Link
      to={to}
      className="inline-flex items-center rounded-full border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-50"
    >
      ← {label}
    </Link>
  );
}

export default BackButton;
